import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import homeIndex from '@/views/home/homeIndex.vue'
import homeInfo from '@/views/home/homeInfo.vue'
import categoryDetail from '@/views/home/category-detail.vue'
import login from '@/views/login/index.vue'
import register from '@/views/register/index.vue'
import ziyuan from '@/views/ziyuan/index.vue'
import Index from '@/views/Index.vue'

export default createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: homeIndex
        },
        {
            path: '/category-detail',
            component: categoryDetail
        },
        {
            path: '/info',
            component: homeInfo
        },
        {
            path: '/login',
            component: login
        }, {
            path: '/register',
            component: register
        },
        {
            path: '/Index',
            component: Index,
            children:[
                {
                    path: '/ziyuan',
                    component: ziyuan
                }
            ]
        },

    ]
})
